import { timeDown } from "@/utils";
import router from "@/router";

/**
 * module name - buyNftHome
 * 法币购买nft首页基本数据
 */

export default {
  namespaced: true,
  state: {
    //展示法币数据
    fiatCurrency: {},
    //nftParamNo
    nftParamNo: "",
    //汇率
    usdToEXR: "",
    //NFT信息
    nftInfo: {
      amount: "", //NFT法币总金额(包含最高费用)
      nftAmount: "", //NFT法币单价
      type: "", //类型 MARKET(二级销售)/MINT(一级销售)
      name: "", //名称
      picture: "", //图片地址
      quantity: "", //数量
      uniqueId: "", //NFT id
      redirectUrl: "", //支付成功后的跳转URL
      appId: "", //商户应用的唯一标识
      timeout: "", //订单时间
      merchantName: "", //商户名称
    },
    //商品价格(不包含支付费用)
    commodityPrice: 0,
    //需要付款金额
    payAmount: 0,
    //完整商户地址栏参数
    merchantParam: "",

    //订单倒计时时间
    orderCountDown: "",
    orderTimeOut: null,

    //选择支付方式的费用
    payWay_rampFee: 0,

    //page商户-币本位接入方式费用信息
    feeInfo: {
      fiatSumAmount: 666.855, //数字货币兑法币金额
      rampFee: 37.02, //rampFee
      netWorkFee: 0.0012, //netWorkFee
      fiat: "USD", //法币单位
      nftname: "NFT name", //NFT名称
    },
    usdAmount: "", // 首页展示;
  },
  mutations: {
    set_fiatCurrency(state, newData) {
      state.fiatCurrency = newData;
    },
    set_usdToEXR(state, newData) {
      state.usdToEXR = newData;
    },
    set_usdAmount(state, newData) {
      state.usdAmount = newData;
    },
    set_nftInfo(state, newData) {
      state.nftInfo = newData;
    },
    set_redirectUrl(state, newData) {
      state.nftInfo.redirectUrl = newData;
    },
    set_merchantName(state, newData) {
      state.nftInfo.merchantName = newData;
    },
    set_commodityPrice(state, newData) {
      state.commodityPrice = newData;
      // state.payAmount = newData;
    },
    set_nftAmount(state, newData) {
      state.nftInfo.nftAmount = newData;
    },
    set_amount(state, newData) {
      state.nftInfo.amount = newData;
    },
    set_payAmount(state, newData) {
      state.payAmount = newData;
    },
    set_merchantParam(state, newData) {
      state.merchantParam = newData;
    },
    set_nftParamNo(state, newData) {
      state.nftParamNo = newData;
    },
    set_orderTime(state, newData) {
      state.nftInfo.timeout = newData;
    },
    set_orderCountDown(state, newData) {
      state.orderCountDown = newData;
    },
    set_orderTimeOut(state, newData) {
      state.orderTimeOut = newData;
    },
    set_payWay_rampFee(state, newData) {
      state.payWay_rampFee = newData;
    },
    set_feeInfo(state, newData) {
      state.feeInfo = newData;
    },
  },
  actions: {
    change_orderTimeOut({ commit, state, rootState }) {
      state.orderTimeOut = null;
      state.orderTimeOut = setInterval(() => {
        var orderTime = Math.round(state.nftInfo.timeout / 1000);
        var nowTime = Math.round(new Date().getTime() / 1000);
        let timeOut_num = orderTime - nowTime || 0;
        if (timeOut_num === 0 && state.nftInfo.timeout !== undefined) {
          commit("set_orderTimeOut", null);
          window.clearInterval(state.orderTimeOut);
          router.push(
            `/paymentResult?customParam=${rootState.buyNftOrder.orderNo}`,
          );
        }
        commit(
          "set_orderCountDown",
          timeDown(timeOut_num) === undefined
            ? "00:00:00"
            : timeDown(timeOut_num),
        );
      }, 1000);
    },
  },
};
